import AirworthyPill from '../AirworthyPill';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { DroneReadiness, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const AirworthyMenu: FunctionComponent<Props> = ({
    className = '',
    onSelect,
    readinessLabels,
    statuses,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const definitions: Record<DroneReadiness, string> = {
        grounded: t.AIRWORTHY_DEFINITION_GROUNDED,
        hold: t.AIRWORTHY_DEFINITION_HOLD,
        ready: t.AIRWORTHY_DEFINITION_READY
    };

    return (
        <VerticalContainer className={`${styles.airworthyMenu} ${className}`} testId={testId}>
            {statuses.map(status => (
                <Wrapper className={styles.menuRow} key={status} onClick={() => onSelect(status)}>
                    <AirworthyPill label={readinessLabels[status]} readiness={status} />

                    <Wrapper className={styles.definition}>{definitions[status]}</Wrapper>
                </Wrapper>
            ))}
        </VerticalContainer>
    );
};

export default AirworthyMenu;
